/**
 * Detects the user's platform for showing appropriate download links
 * Returns 'ios' for iOS devices, 'android' for Android devices, or 'desktop' for laptops/desktops
 * 
 * IMPORTANT: Does NOT assume MacBook = iPhone - checks for actual mobile device strings
 */
export function detectPlatform(): 'ios' | 'android' | 'desktop' {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'desktop';
  }

  const userAgent = navigator.userAgent.toLowerCase();

  // Check for iOS devices (iPhone, iPad, iPod)
  // Must be actual mobile device strings, not just macOS
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  }

  // Check for Android devices
  if (/android/.test(userAgent)) {
    return 'android';
  }

  // Everything else (including MacBook, Windows laptops, etc.) is desktop
  return 'desktop';
}


